import * as React from "react"
import { cn } from "@/lib/utils"
import { HugeiconsIcon } from "@hugeicons/react"
import { Loading01Icon } from "@hugeicons/core-free-icons"

function Spinner({ className, ...props }: Omit<React.ComponentProps<typeof HugeiconsIcon>, 'icon'>) {
  return (
    <HugeiconsIcon icon={Loading01Icon} role="status"
      aria-label="Loading"
      className={cn("size-4 animate-spin", className)}
      {...props} />
  )
}

export { Spinner }
